import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store.types';
import { getWindow } from 'core-framework/util/Dom';

export enum MenuWindowState {
    Closed,
    Open,
    FullWidth,
}

export interface MenuState {
    menuState: MenuWindowState;
    screen: {
        width: number;
        height: number;
    };
}

export const initialState: MenuState = {
    menuState: MenuWindowState.Closed,
    screen: {
        width: 1024,
        height: 1080,
    },
};

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setMenuState: (state, action: PayloadAction<MenuWindowState>) => {
            state.menuState = action.payload;
        },
        onWindowResize: (state, _: PayloadAction<undefined>, windowProvider = getWindow) => {
            const windowObj = windowProvider();
            state.screen.width = windowObj.innerWidth;
            state.screen.height = windowObj.innerHeight;
        },
    },
});

const selectMenuState = (state: RootState) => state.menu;

export const selectIsMenuOpen = createSelector(selectMenuState, (state) => state.menuState === MenuWindowState.Open || state.menuState === MenuWindowState.FullWidth);
export const selectScreenWidth = createSelector(selectMenuState, (state) => state.screen.width);
export const selectScreenHeight = createSelector(selectMenuState, (state) => state.screen.height);

export const { setMenuState, onWindowResize } = menu.actions;
export default menu.reducer;
